const MAX_FILE_SIZE = 5 * 1024 ** 2 // 5MB

export const formatFileSize = (size: number = MAX_FILE_SIZE) => {
  return `${(size / 1024 / 1024).toFixed(2)}`
}
